module.exports = __webpack_public_path__ + "static/img/btn_zhinan_nor.7eb2fc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_zhinan_nor.png
// module id = vgHR
// module chunks = 1